import {Encryptor} from "encryption/Encryptor";
import {Decryptor} from "encryption/Decryptor";

/**
 *  Utility class for data encryption and decryption
 *
 */
export function EncryptionService( cryptToken, useLegacyEncoder ){

    const encryptor = new Encryptor( cryptToken, useLegacyEncoder ),
          decryptor = new Decryptor( cryptToken, useLegacyEncoder );

    // revealing public api
    return {
        /**
         * encrypt given data
         *
         * @param {String} data
         * @return encrypted data
         */
        encryptData : encryptor.encryptData,

        /**
         * decrypt given encrypted data.
         *
         * @param {String} data
         * @return decrypted data
         */
        decryptData : decryptor.decryptData
    };
}
